import { combineReducers } from 'redux';
import Quoting from './quoting';
import settings from './settings';

export default combineReducers({
  quoting: Quoting,
  settings,
});
